import { ViewChild, Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

import { ModalComponent, NotifyService, ToastType } from 'app/notify';
import { AuthHttpService } from 'app/security/authorization';
import { UploaderOptions } from '../uploader-options.model';

@Component({
  templateUrl: './modal-uploader.component.html',
  styleUrls: ['./modal-uploader.component.scss']
})
export class ModalUploaderComponent extends ModalComponent<void> implements OnInit, OnDestroy {

  @ViewChild('closeButton')
  public closeButton: ElementRef;
  @ViewChild('fileUpload')
  public fileUpload: FileUpload;
  public options: UploaderOptions = null;
  public toasts: any[] = [];

  private importUrl: string = '';
  private dropAreaClassName: string = 'drop-area-hover';
  private lastActiveElement: any = null;

  constructor(
    private authHttpService: AuthHttpService,
    private notify: NotifyService,
    private translateService: TranslateService,
  ) {
    super();
  }

  public ngOnInit() {
    document.body.ondragover = () => {
      this.addDropClass();
    };
    document.body.ondragleave = () => {
      this.removeDropClass();
    };

    this.lastActiveElement = document.activeElement;
  }

  ngAfterViewInit() {
    this.closeButton.nativeElement.focus();
  }

  public dismiss(): void {
    super.dismiss();

    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }

  public ngOnDestroy() {
    document.body.ondragover = null;
    document.body.ondragleave = null;
  }

  public setOptions(options: UploaderOptions) {
    this.options = options;
  }

  public upload(): void {
    this.fileUpload.upload();
  }

  public canUpload(): boolean {
    return this.fileUpload.hasFiles();
  }

  public uploadSuccess(res) {
    this.notify.toast(ToastType.SUCCESS, this.translateService.instant('uploader.success_send_file'));
    super.close(res.response.publicId);
  }

  public uploadError(request: XMLHttpRequest) {
    this.notify.alert(
      this.translateService.instant('uploader.check_file_format'),
      this.translateService.instant('uploader.error')
    );
  }

  public attachAuthHeaders(request: XMLHttpRequest) {
    if (!this.options.auth) {
      return;
    }

    const token: string = this.authHttpService.getPrefixedToken();
    const tokenHeaderName: string = AuthHttpService.getTokenHeaderName();

    request.setRequestHeader(tokenHeaderName, token);
    request.responseType = this.options.responseType;
  }

  private addDropClass() {
    if (document.body.className.indexOf(this.dropAreaClassName) > -1) {
     return;
    }

    document.body.classList.add(this.dropAreaClassName);
  }

  private removeDropClass() {
    if (document.body.className.indexOf(this.dropAreaClassName) === -1) {
      return;
    }

    document.body.classList.remove(this.dropAreaClassName);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/uploader/modal-uploader/modal-uploader.component.ts